export const ERROR_MESSAGE = {
  ReleaseID: 'Organization ID Already Exists. Please choose a unique ID for your organization',
  department: 'Department Already Exists. Please use a different name for the department.',
};
